import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/ui/screens/privacy/PrivacyWrapper.tsx");
